import React, { Fragment } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { format } from '@src/utils';
import { Space } from '@ywk/mobile-components';
import { Icon } from 'antd-mobile';
import { observer } from 'mobx-react';
import { IProjectItem } from '@src/entity/company/project';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface IItem extends IProjectItem, RouteComponentProps {}
const ListItem = observer((props: IItem) => {
  const {
    name,
    owner,
    end_at_stmp,
    done_rate,
    done_count,
    delay_count,
    all_task,
    slug,
    color,
    pstatus,
    history
  } = props;
  if (!slug || !name) {
    return null;
  }
  // const tempName = user.split(",");
  // const username = tempName.length > 1 ? `${tempName[0]}...` : user;
  const time = `${format.limitTime(end_at_stmp)}`;
  const _color = color === 'blue' ? '#3BA0FF' : '#F5222D';
  let timeClass = '';
  if (time) {
    if (time.includes('延期')) {
      timeClass = 'expire';
    }
    if (time.includes('今天')) {
      timeClass = 'now';
    }
  }

  return (
    <div
      onClick={() => {
        if (process.env.NODE_ENV === 'development') {
          history.push(`/company/project/detail/${slug}`);
        }
        window.YwkHybrid.page.open({
          pageUrl: `${location.origin}/company/project/detail/${slug}`
        });
      }}
      className="ProjectList-ListItem"
    >
      {/* <Link
      onClick={() => {
        const { project } = mobxState.company;
        project.resetFilter();
      }}
      to={`/company/project/detail/${slug}`}
      className="ProjectList-ListItem"
    > */}
      <div className="sub">
        <CircularProgressbar
          styles={buildStyles({
            pathColor: _color,
            textColor: done_rate === 0 && delay_count === 0 ? '#8c8c8c' : _color
          })}
          value={done_rate}
          text={`${done_rate}%`}
        />
      </div>
      <div className="main">
        <h3>{name}</h3>
        <p>
          {owner && (
            <span>
              {owner}
              <Space className="toggle-line" />
            </span>
          )}
          {time ? (
            <Fragment>
              <time className={timeClass}>{time}</time>
              <Space className="toggle-line" />
            </Fragment>
          ) : null}
          {/* <img className= src={require('../../../assets/images/company/icon-finished.png')} /> */}
          <Icon size="xxs" type="check-circle-o" />
          {done_count}/{all_task}
        </p>
      </div>
      {/* </Link> */}
    </div>
  );
});

export default withRouter(ListItem);
